export enum PlottingVariables {
  TEMPERATUR = 'temperature',
  REGEN = 'precipitation',
  SONNENSCHEIN = 'sunshine_duration',
  WINDGESCHWINDIGKEIT = 'wind_speed',
}
